import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "./../../../component/atoms/layout/detail/detailTop";
import GoBack from "./../../../component/molecules/goBack";
import BlueBtn from "./../../../component/atoms/button/blueBtn";
import RedBtn from "./../../../component/atoms/button/redBtn";
import DetailPage from "./../../../component/atoms/layout/detail/detailPage";
import PretendardText from "../../../component/atoms/text/pretendardText";
import { route } from "../../../router/route";
import FaqApi from "../../../api/faq.api";
import { errorHandler } from "../../../util/errorHandler";
import moment from "moment";
import QuillEditorReadOnly from "../../../component/molecules/quillEditorReadOnly";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";

const OperationFaqDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.operation_faq)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [faqInfo, setFaqInfo] = useState();

  useEffect(() => {
    getFaqInfoFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getFaqInfoFunc = async () => {
    try {
      const response = (await FaqApi.getFaqDetail(id)).data.data.content;

      setFaqInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteFunc = async () => {
    try {
      let data = {
        ids: [faqInfo.id],
        allFlag: false,
      };

      await FaqApi.delFaq(data);

      toast(toastMsg.delete);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            {isWriteAuthority && (
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: 12,
                }}
              >
                <BlueBtn
                  onClick={() => {
                    navigate(`${route.operation_faq_edit}/${id}`);
                  }}
                >
                  수정
                </BlueBtn>
                <RedBtn
                  onClick={() => {
                    deleteFunc();
                  }}
                >
                  삭제
                </RedBtn>
              </div>
            )}
          </DetailTop>
          <DetailPage>
            <ContentTitle>{faqInfo?.question}</ContentTitle>
            <ContentSubTitleWrapper>
              <ContentSubTitle>제디피트</ContentSubTitle>
              <TextDivider />
              <ContentSubTitle>자주 묻는 질문</ContentSubTitle>
              <TextDivider />
              <ContentSubTitle
                style={{
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                {moment(faqInfo?.createdAt).format("YYYY-MM-DD")}
              </ContentSubTitle>
            </ContentSubTitleWrapper>

            <ContentDivider
              style={{
                marginBottom: 30,
              }}
            />

            {/* 본문 영역 */}
            <ContentParagraphWrapper>
              <QuillEditorReadOnly content={faqInfo?.content} />
            </ContentParagraphWrapper>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationFaqDetail;

const ContentTitle = styled(PretendardText).attrs((props) => {})`
  font-size: 18px;
  font-weight: 600;
  line-height: 32.5px;
  color: #f3f3f3;
  margin: 14px 0px 10px 0px;
`;

const ContentSubTitleWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`;

const ContentSubTitle = styled(PretendardText).attrs((props) => {})`
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  color: #aaa;
`;

const TextDivider = styled.span.attrs((props) => {})`
  width: 1px;
  height: 19px;
  background-color: rgba(255, 255, 255, 0.12);
`;

const ContentDivider = styled.div.attrs((props) => {})`
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.12);
`;

const ContentParagraphWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: "fit-content";
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 100px;
`;

const ContentParagraph = styled(PretendardText).attrs((props) => {})`
  font-weight: 400;
  font-size: 15px;
  line-height: 21.5px;
  color: #aaa;
`;
